export const Address = [
  [
    {
      value: "ACT",
      label: "Australian Capital Territory",
    },
    {
      value: "NSW",
      label: "New South Wales",
    },
    {
      value: "NT",
      label: "Northern Territory",
    },
    {
      value: "QLD",
      label: "Queensland",
    },
    {
      value: "SA",
      label: "South Australia",
    },
    {
      value: "TAS",
      label: "Tasmania",
    },
    {
      value: "VIC",
      label: "Victoria",
    },
    {
      value: "WA",
      label: "Western Australia",
    },
    {
      value: "Others",
      label: "Others",
    },
  ],
];



export const StateAddress = [
  [
    {
      value: "ACT",
      label: "Australian Capital Territory",
    },
    {
      value: "NSW",
      label: "New South Wales",
    },
    {
      value: "NT",
      label: "Northern Territory",
    },
    {
      value: "QLD",
      label: "Queensland",
    },
    {
      value: "SA",
      label: "South Australia",
    },
    {
      value: "TAS",
      label: "Tasmania",
    },
    {
      value: "VIC",
      label: "Victoria",
    },
    {
      value: "WA",
      label: "Western Australia",
    },
    
  ],
];



export const stateByCountry = [
  {
    name: "Australia",
    code: "AU",
    states: [
      { name: "New South Wales", code: "NSW" },
      { name: "Victoria", code: "VIC" },
      { name: "Queensland", code: "QLD" },
      { name: "Western Australia", code: "WA" },
      { name: "South Australia", code: "SA" },
      { name: "Tasmania", code: "TAS" },
      { name: "Australian Capital Territory", code: "ACT" },
      { name: "Northern Territory", code: "NT" },
    ],
    state_label: "State",
    suburb_label: "Suburb",
  },
  {
    name: "Canada",
    code: "CA",
    provinces: [
      { name: "Alberta", code: "AB" },
      { name: "British Columbia", code: "BC" },
      { name: "Manitoba", code: "MB" },
      { name: "New Brunswick", code: "NB" },
      { name: "Newfoundland and Labrador", code: "NL" },
      { name: "Nova Scotia", code: "NS" },
      { name: "Ontario", code: "ON" },
      { name: "Prince Edward Island", code: "PE" },
      { name: "Quebec", code: "QC" },
      { name: "Saskatchewan", code: "SK" },
      { name: "Northwest Territories", code: "NT" },
      { name: "Nunavut", code: "NU" },
      { name: "Yukon", code: "YT" },
    ],
    state_label: "Province",
    suburb_label: "City",
  },
  {
    name: "United Kingdom",
    code: "GB",
    regions: [
      { name: "England", code: "ENG" },
      { name: "Scotland", code: "SCT" },
      { name: "Wales", code: "WLS" },
      { name: "Northern Ireland", code: "NIR" },
    ],
    state_label: "Region",
    suburb_label: "City",
  },
];
